import script from "./Whatsapp.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Whatsapp.vue?vue&type=script&setup=true&lang=ts"
export * from "./Whatsapp.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Whatsapp.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__